module.exports = __webpack_public_path__ + "img/down_load_invoices_one.dd3e030b.png";